<admin-app-header></admin-app-header>

<div class="container admin-page py-4">
    <div class="row mb-3">
        <div class="col-12">
            <a [routerLink]="['/admin/cms/faqs']" class="text-muted text-decoration-none">
                <i class="fa-solid fa-chevron-left me-1"></i> Back to FAQs
            </a>
            <h2 class="mt-2">{{ faqKey ? 'Edit FAQ' : 'New FAQ' }}</h2>
        </div>
    </div>

    <div *ngIf="loading" class="text-muted">Loading...</div>

    <form *ngIf="!loading" [formGroup]="formGroup" (ngSubmit)="save()">
        <div class="alert alert-danger" *ngIf="error">{{ error }}</div>

        <div class="mb-3">
            <label class="form-label">Category</label>
            <div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="cat-client" formControlName="category" value="client" />
                    <label class="form-check-label" for="cat-client">Driver (Parker)</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="cat-merchant" formControlName="category" value="merchant" />
                    <label class="form-check-label" for="cat-merchant">Property Owner (Landlord)</label>
                </div>
            </div>
        </div>

        <div class="mb-3">
            <label class="form-label" for="faq-question">Question</label>
            <input id="faq-question" type="text" class="form-control" formControlName="question" placeholder="e.g. How can I list my parking on ParkUpp?" />
        </div>

        <div class="mb-3">
            <label class="form-label">Answer</label>
            <quill-editor formControlName="answer" placeholder="Write the answer..." [styles]="{ minHeight: '180px' }"></quill-editor>
            <div class="form-text">You can format text (bold, italic, lists, links, headings).</div>
        </div>

        <div class="row">
            <div class="col-md-3 mb-3">
                <label class="form-label" for="faq-order">Order</label>
                <input id="faq-order" type="number" class="form-control" formControlName="order" />
                <div class="form-text">Lower numbers show first.</div>
            </div>
            <div class="col-md-9 mb-3 d-flex align-items-end">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="faq-published" formControlName="published" />
                    <label class="form-check-label" for="faq-published">Published (visible on /faqs)</label>
                </div>
            </div>
        </div>

        <div class="d-flex gap-2">
            <button type="submit" class="btn btn-primary" [disabled]="saving">
                <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
                {{ faqKey ? 'Save changes' : 'Create FAQ' }}
            </button>
            <button type="button" class="btn btn-outline-secondary" (click)="cancel()" [disabled]="saving">Cancel</button>
        </div>
    </form>
</div>
